<script>
  /**@type {any}*/
  let mainVideo;
  let isplay = false;
  /**@type {any}*/
  // let selectedVideo = "Rw79gjy32F4";
  let selectedVideo = "FNKdVQ_p5hA";
</script>

<svelte:head>
  <title>Videos - Red Carpet Manicure</title>
  <meta property="og:title" name="title" content="Red Carpet Manicure" />
  <meta
    property="og:description"
    name="description"
    content="Red Carpet Manicure"
  />
</svelte:head>

<div class="wrap">
  <div class="main-video">
    <iframe
      src={`https://www.youtube.com/embed/${selectedVideo}?enablejsapi=1`}
      title="RCM"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      referrerpolicy="strict-origin-when-cross-origin"
      allowfullscreen
    />
  </div>

  <div class="videos-grid">
    <button class="card-video" on:click={()=> selectedVideo = "FNKdVQ_p5hA"}>
      <img src="/images/more_tutorials/default_cream_gel0.jpg" alt="" />
    </button>
    <button class="card-video" on:click={()=> selectedVideo = "iYXm9SxKSLs"}>
      <img src="/images/more_tutorials/maxresdefault.jpg" alt="" />
    </button>
    <button class="card-video" on:click={()=> selectedVideo = "Y9edQO09uX4"}>
      <img src="/images/more_tutorials/maxresdefault_1.jpg" alt="" />
    </button>
    <button class="card-video" on:click={()=> selectedVideo = "fEbfSK8yZfM"}>
      <img src="/images/more_tutorials/maxresdefault_2.jpg" alt="" />
    </button>
    <button class="card-video" on:click={()=> selectedVideo = "RAXf9B7Wnjg"}>
      <img src="/images/more_tutorials/maxresdefault_3.jpg" alt="" />
    </button>
  </div>
</div>

<style>
  /* Second column */
  .main-video {
    position: relative;
    height: fit-content;
    aspect-ratio: 1.77/1;
    margin: 15rem auto 6rem auto;
    width: 100%;
    max-width: 120rem;  
  }
  iframe {
    width: 100%;
    aspect-ratio: 1.77/1;
    margin: 0 auto;
    /* pointer-events: none; */
    user-select: none;
    border: none;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
  }
  .videos-grid {
    width: 95svw;
    max-width: 120rem;
    margin: 6rem auto;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 2rem;
  }
  .videos-grid .card-video {
    border: none;
    border-radius: 2rem;
    cursor: pointer;
  }
  .videos-grid .card-video img {
    border-radius: 2rem;
    object-fit: cover;
    object-position: center;
  }
  @media (max-width: 920px) {
    .main-video {
      width: 95svw;
      max-width: 95svw;
      grid-column: 1/-1;
      grid-row: 2/3;
    }
    iframe {
      width: 95svw;
      max-width: 95svw;
    }
  }
</style>
